const apiUrl = process.env.REACT_APP_API_URL;
const base = `${apiUrl}:8061`;

function authHeaders(json = true): Record<string, string> {
    const h: Record<string, string> = {
        'Authorization': `Bearer ${localStorage.getItem('authToken') || localStorage.getItem('token') || ''}`
    };
    if (json) h['Content-Type'] = 'application/json';
    return h;
}

export async function GetCazaRecompenses(idCaza: number | string, idConjunt?: number | string) {
    try {
        const query = idConjunt ? `?id_conjunt=${idConjunt}` : '';
        const res = await fetch(`${base}/jutge/caza/${idCaza}/recompenses${query}`, { headers: authHeaders(false) });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al obtener recompensas de la píldora:', e);
        return [];
    }
}

export async function PostCazaRecompensa(idCaza: number | string, recompensa: any) {
    try {
        const res = await fetch(`${base}/jutge/caza/${idCaza}/recompenses`, {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify(recompensa)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al añadir recompensa a la píldora:', e);
        return false;
    }
}

export async function DeleteCazaRecompensa(idCaza: number | string, idRecompensa: number | string) {
    try {
        const res = await fetch(`${base}/jutge/caza/${idCaza}/recompenses/${idRecompensa}`, {
            method: 'DELETE',
            headers: authHeaders(false)
        });
        return res.ok;
    } catch (e) {
        console.error('Error al eliminar recompensa de la píldora:', e);
        return false;
    }
}

export async function GetCazaUsuarisRecompenses(idCaza: number | string, idConjunt?: number | string) {
    try {
        const query = idConjunt ? `?id_conjunt=${idConjunt}` : '';
        const res = await fetch(`${base}/jutge/caza/${idCaza}/recompenses/usuaris${query}`, { headers: authHeaders(false) });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return await res.json();
    } catch (e) {
        console.error('Error al obtener historial de recompensas de la píldora:', e);
        return [];
    }
}
